import { FieldsBase } from './fields-base';

export class FieldsArea extends FieldsBase<string> {
  controlType = 'textarea';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}